const WA_CHANNEL = 'https://whatsapp.com/channel/0029VbCjXXHFcow1ohd1CY09';

const socials = [
  {
    logo: 'https://img.icons8.com/color/96/youtube-play.png',
    label: 'YouTube',
    handle: '@ShayGeneration',
    cta: 'Subscribe',
    href: 'https://www.youtube.com/@ShayGeneration',
    color: '#FF4444',
    bg: 'rgba(255,68,68,0.10)',
    border: 'rgba(255,68,68,0.30)',
    desc: 'Messages, worship sets & revival highlights',
  },
  {
    logo: 'https://img.icons8.com/color/96/instagram-new--v1.png',
    label: 'Instagram',
    handle: '@shay_this_generation',
    cta: 'Follow',
    href: 'https://www.instagram.com/shay_this_generation',
    color: '#E1306C',
    bg: 'rgba(225,48,108,0.10)',
    border: 'rgba(225,48,108,0.30)',
    desc: 'Stories, updates & behind-the-scenes moments',
  },
  {
    logo: 'https://img.icons8.com/color/96/facebook.png',
    label: 'Facebook',
    handle: 'SHAY Generation',
    cta: 'Like Page',
    href: 'https://www.facebook.com/profile.php?id=61578513957131',
    color: '#4A90D9',
    bg: 'rgba(74,144,217,0.10)',
    border: 'rgba(74,144,217,0.30)',
    desc: 'Community posts, events & announcements',
  },
  {
    logo: 'https://img.icons8.com/color/96/whatsapp.png',
    label: 'WhatsApp',
    handle: 'Reclaim Conference 2026',
    cta: 'Join',
    href: WA_CHANNEL,
    color: '#25D366',
    bg: 'rgba(37,211,102,0.10)',
    border: 'rgba(37,211,102,0.30)',
    desc: 'Direct updates straight to your WhatsApp',
  },
];

const StayConnected = () => {
  return (
    <section
      id="stay-connected"
      className="relative py-24 px-6 lg:px-12 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #080808 0%, #060606 100%)' }}
    >
      {/* Top border */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.55), transparent)' }}
      />

      {/* Ambient glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: '900px',
          height: '600px',
          background: 'radial-gradient(ellipse, rgba(212,168,66,0.06) 0%, transparent 60%)',
        }}
      />

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div
            className="inline-flex items-center gap-2 mb-6 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
            style={{
              background: 'rgba(212,168,66,0.1)',
              border: '1px solid rgba(212,168,66,0.35)',
              color: '#D4A842',
              fontFamily: "'Glacial Indifference', sans-serif",
            }}
          >
            <span>✦</span> Follow the Movement
          </div>
          <h2
            className="font-black uppercase mb-3"
            style={{
              fontFamily: "'Glacial Indifference', sans-serif",
              fontSize: 'clamp(2rem, 5vw, 3rem)',
              color: '#FFFFFF',
              textShadow: '0 0 40px rgba(212,168,66,0.2)',
            }}
          >
            Stay Connected
          </h2>
          <p
            className="text-sm leading-relaxed max-w-sm mx-auto"
            style={{ color: '#666', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            Be part of what God is doing — follow us across every platform.
          </p>
        </div>

        {/* 2x2 Social Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              rel="nofollow noreferrer"
              target="_blank"
              className="group flex flex-col gap-3 p-5 rounded-2xl cursor-pointer transition-all duration-300 hover:scale-[1.02]"
              style={{
                background: s.bg,
                border: `1px solid ${s.border}`,
              }}
            >
              {/* Top row: logo image + label + cta */}
              <div className="flex items-center gap-4">
                {/* Actual brand logo image */}
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <img
                    src={s.logo}
                    alt={`${s.label} logo`}
                    className="w-10 h-10 object-contain"
                  />
                </div>

                {/* Label + handle */}
                <div className="flex flex-col flex-1 min-w-0">
                  <span
                    className="font-black uppercase tracking-wide leading-tight"
                    style={{
                      fontFamily: "'Glacial Indifference', sans-serif",
                      fontSize: '1rem',
                      color: '#fff',
                    }}
                  >
                    {s.label}
                  </span>
                  <span
                    className="text-xs mt-0.5 leading-snug break-all"
                    style={{ color: s.color, fontFamily: "'Glacial Indifference', sans-serif" }}
                  >
                    {s.handle}
                  </span>
                </div>

                {/* CTA pill */}
                <div
                  className="flex-shrink-0 px-4 py-2 rounded-full text-xs font-bold tracking-wide uppercase whitespace-nowrap"
                  style={{
                    background: s.bg,
                    border: `1px solid ${s.border}`,
                    color: s.color,
                    fontFamily: "'Glacial Indifference', sans-serif",
                  }}
                >
                  {s.cta}
                </div>
              </div>

              {/* Description */}
              <p
                className="text-xs leading-relaxed"
                style={{ color: '#666', fontFamily: "'Glacial Indifference', sans-serif" }}
              >
                {s.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StayConnected;
